import { render, staticRenderFns } from "./BeianFooter.vue?vue&type=template&id=44292b24&scoped=true"
import script from "./BeianFooter.vue?vue&type=script&lang=js"
export * from "./BeianFooter.vue?vue&type=script&lang=js"
import style0 from "./BeianFooter.vue?vue&type=style&index=0&id=44292b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44292b24",
  null
  
)

export default component.exports